import { Button } from "@/components/ui/button";
import Link from "next/link";
import { IoBugOutline } from "react-icons/io5";
export default function AccountSupport() {
  return <div className="h-full w-full px-4" data-sentry-component="AccountSupport" data-sentry-source-file="AccountSupport.tsx">
            <div className="w-full h-[80%] flex items-center justify-center ta-c">
                <div className="w-full">
                    <IoBugOutline className="text-[100px] text-genius-pink py-6" data-sentry-element="IoBugOutline" data-sentry-source-file="AccountSupport.tsx" />

                    <p className="text-[16px] text-genius-cream/50 mb-8">Report a Bug or Request a Feature</p>
                    <Link href="https://support.tradegenius.com" target="_blank" data-sentry-element="Link" data-sentry-source-file="AccountSupport.tsx">
                        <Button className="w-[377px] text-[18px] rounded-full bg-genius-blue h-[61px] text-genius-cream" data-sentry-element="Button" data-sentry-source-file="AccountSupport.tsx">
                            Bug Reports/Feature Requests
                        </Button>

                    </Link>
                </div>
            </div>

        </div>;
}